"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = exports.configurationContextDefaultValues = exports.configurationContext = exports.ConfigurationProvider = void 0;
var _react = require("react");
const configurationContextDefaultValues = exports.configurationContextDefaultValues = {
  currentLanguage: '',
  registrationType: 'Consultant',
  customerDashboardUrl: '',
  loginRedirectUrl: '',
  registrationId: '',
  validationErrorCode: '',
  customerLoginUrl: '',
  customerServiceUrl: '',
  isEnabled: false
};
const configurationContext = exports.configurationContext = /*#__PURE__*/(0, _react.createContext)(configurationContextDefaultValues);
const ConfigurationProvider = exports.ConfigurationProvider = configurationContext.Provider;
const useConfiguration = () => (0, _react.useContext)(configurationContext);
exports.useConfiguration = useConfiguration;